module.exports = __webpack_public_path__ + "static/media/Afya.aa71c269.jpg";